<script>
  import WallsWidgetService from './service.js';
  export let wrapperClasses = '', post;

  let isMember;
  WallsWidgetService.isMember().then((res) => (isMember = res));

  let upvotes = post.reactions?.upvote || { count: 0, reacted: 0 };
  let downvotes = post.reactions?.downvote || { count: 0, reacted: 0 };

  const onUpvote = () => {
    if (!isMember) {
      return;
    }

    if (upvotes.reacted) {
      WallsWidgetService.removeReaction(post.id);
      upvotes.count -= 1;
      upvotes.reacted = false;

      return;
    }

    WallsWidgetService.giveReaction(post.id, 'upvote');
    downvotes = revertOtherVoteIfNecessary(downvotes);
    upvotes.count += 1;
    upvotes.reacted = true;
  };

  const onDownvote = () => {
    if (!isMember) {
      return;
    }

    if (downvotes.reacted) {
      WallsWidgetService.removeReaction(post.id);
      downvotes.count -= 1;
      downvotes.reacted = false;
    }

    WallsWidgetService.giveReaction(post.id, 'downvote');
    upvotes = revertOtherVoteIfNecessary(upvotes);
    downvotes.count += 1;
    downvotes.reacted = true;
  };

  const revertOtherVoteIfNecessary = (reaction) => {
    if (reaction.reacted) {
      return {
        count: reaction.count - 1,
        reacted: false
      };
    }

    return reaction;
  };
</script>

<div class="post-upvote-wrapper {wrapperClasses}">
  <div class:active={upvotes.reacted} on:mouseup|stopPropagation={onUpvote} class="post-upvote-button">
    <svg style="margin-bottom: 2px;" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"
    ><path d="M248.911-386.999 480-618.088l231.089 231.089H248.911Z"></path></svg>
    <span class="post-upvote-counter mb-5">{upvotes.count}</span>
  </div>
  <div class:active={downvotes.reacted} on:mouseup|stopPropagation={onDownvote} class="post-upvote-button">
    <span class="post-upvote-counter mt-5">{downvotes.count}</span>
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"
    ><path d="M480-341.912 248.911-573.001h462.178L480-341.912Z"></path></svg>
  </div>
</div>
